import { HIDE_DATA_SYMBOL, UNBREAKABLE_SEPARATOR } from 'constants/string';

import type { TPassportFormFields } from 'entities/creditForm';

export const getProtectedTitleWithUserData = (data: Nullable<TPassportFormFields>, isHideData = false) => {
  if (!data?.fullName) {
    return '';
  }

  return isHideData ? Array(3).fill(HIDE_DATA_SYMBOL.repeat(4)).join(UNBREAKABLE_SEPARATOR) : data.fullName.value;
};
